<script>
	import { useLocation } from "svelte-navigator";

    import { pageNumber } from '../stores';

    export let pageList = [];
    
    let currentPage = null;
      
    const location = useLocation();

    $: {
        currentPage = pageList.find(p => p.routeId == $location.pathname);
        if (currentPage) {
            $pageNumber = currentPage ? currentPage.pageIndex : 0;
        } else {
            currentPage = pageList[0];
            $pageNumber = 0;
        }
    }
</script>

{#if (pageList && pageList.length > 0)}

    <div class="tracker-root no-print">
        <div class="row">
            {#each pageList as page}

                    {@const visited = page.pageIndex < $pageNumber}
                    {@const active = page.pageIndex == $pageNumber}

                    {#if (page.showInTracker && $pageNumber > 0)}
                        <div class="col" class:visited class:active>
            
                        </div>
                    {/if}
            {/each}
        </div>

        {#if (currentPage.title)}
            <div class="page-title">
                {currentPage.title.toUpperCase()}
            </div>
        {/if}
    </div>

{/if}



<style>

    .tracker-root {
        padding-top: 16px;
        padding-bottom: 40px;
        margin: 0 13.5px;
    }

    .col {
        height: 6px;
        background-color: #000;
    }

    .col.visited,
    .col.active {
        background-color: var(--color-primary);
    }

    .page-title {
        text-align: center;
        padding-top: 10px;
        color: #222;
        font-size: 11px;
        font-weight: 700;
    }

</style>